/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * The carve-outs-only package for this submission. s3_url is absent while a generation is in flight.
 * @export
 * @interface CarveOutsDocument
 */
export interface CarveOutsDocument {
    /**
     * 
     */
    generated_at?: Date;
    /**
     * 
     */
    s3_url?: string;
}

/**
 * Check if a given object implements the CarveOutsDocument interface.
 */
export function instanceOfCarveOutsDocument(value: object): value is CarveOutsDocument {
    return true;
}

export function CarveOutsDocumentFromJSON(json: any): CarveOutsDocument {
    return CarveOutsDocumentFromJSONTyped(json, false);
}

export function CarveOutsDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutsDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'generated_at': json['generated_at'] == null ? undefined : (parseDateTime(json['generated_at'])),
        's3_url': json['s3_url'] == null ? undefined : json['s3_url'],
    };
}

export function CarveOutsDocumentToJSON(json: any): CarveOutsDocument {
    return CarveOutsDocumentToJSONTyped(json, false);
}

export function CarveOutsDocumentToJSONTyped(value?: CarveOutsDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generated_at': value['generated_at'] == null ? value['generated_at'] : serializeDateTime(value['generated_at']),
        's3_url': value['s3_url'],
    };
}

